import { Component, Listen, Query } from '@atomify/core';
import { Fragment, h } from '@atomify/jsx';
import getComponentData from '@atoms/component-data/utils/get-component-data';
import imageStyle from '@atoms/image/image.scss';
import defaultExteriorThumbnail from '@public/assets/images/map-switch-thumbnail-exterior.jpg';
import defaultInteriorThumbnail from '@public/assets/images/map-switch-thumbnail-interior.jpg';
import { elements } from '@utilities/dom';

import style from './map-switch.scss';
import MapSwitchToggle from './utilities/map-switch-toggle';

interface ToggleInterface {
    label: string;
    image: string;
}

interface DataInterface {
    interiorToggle: ToggleInterface;
    exteriorToggle: ToggleInterface;
}

const VIEW_EXTERIOR = 'map-switch--view-exterior';

@Component({
    tag: 'bpd-map-switch',
    styles: [style, imageStyle],
    shadow: true,
})
export class BPDMapSwitch extends HTMLElement {
    @Query('[js-hook-map-switch]') container: HTMLElement;
    @Query('[js-hook-map-switch-toggle]') toggleButton: HTMLButtonElement;

    data: DataInterface | null = getComponentData<DataInterface>(this);

    async componentWillRender() {
        this.setDefaultImages();
    }

    setDefaultImages() {
        if (!this.data) return;

        if (!this.data.interiorToggle.image)
            this.data.interiorToggle.image = defaultInteriorThumbnail;

        if (!this.data.exteriorToggle.image)
            this.data.exteriorToggle.image = defaultExteriorThumbnail;
    }

    @Listen('click', { target: 'toggleButton' })
    toggle() {
        // Toggle class on both body and component, because component has shadowDOM
        this.container.classList.toggle(VIEW_EXTERIOR);
        elements.body.classList.toggle(VIEW_EXTERIOR);
    }

    render() {
        return (
            <div class="c-map-switch" js-hook-map-switch>
                <div class="map-switch__container">
                    <div class="map-switch__interior">
                        <slot name="interior"></slot>
                    </div>

                    <div class="map-switch__exterior">
                        <slot name="exterior"></slot>
                    </div>

                    <button class="map-switch__toggle" js-hook-map-switch-toggle>
                        {this.data?.interiorToggle && this.data?.exteriorToggle && (
                            <Fragment>
                                <MapSwitchToggle
                                    className="map-switch__toggle-exterior"
                                    {...this.data.exteriorToggle}
                                />
                                <MapSwitchToggle
                                    className="map-switch__toggle-interior"
                                    {...this.data.interiorToggle}
                                />
                            </Fragment>
                        )}
                    </button>
                </div>
            </div>
        );
    }
}
